const OPTIMIZELY_KEY_DEV = 'XXcjL4rLPPTubAzaw8b5i';
const OPTIMIZELY_KEY_PROD = '9KQ1JuFcioT3pwRA8TLLn';
const SHIPPING_FEE_TOGGLE = 'shipping_fee_a_b_test';

export { OPTIMIZELY_KEY_DEV, OPTIMIZELY_KEY_PROD, SHIPPING_FEE_TOGGLE };
//# sourceMappingURL=constants.js.map
